import { useSelector } from "react-redux"

export const useIsCourseExpanded = activityCourse =>
  useSelector(state =>
    state.mycourses.expandedCourses.includes(activityCourse.id)
  )

export const useIsLevelExpanded = level =>
  useSelector(state => state.mycourses.expandedLevels.includes(level.id))



// WEBPACK FOOTER //
// ./src/components/mycourses/hooks/useIsExpanded.js